enum CookieConsentDataSourceEnum {
	disabled = 'Disabled',
	oneWeb = 'OneWeb',
	block = 'Block'
}

export default CookieConsentDataSourceEnum;
